import BatchSendcmdModal from './batch-send-cmd-modal.vue'
export default BatchSendcmdModal
